import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Cliente } from '../../../../types/Cliente.type';
import { ClienteBasicoResponse } from '../../../../types/ClienteBasicoResponse.type';
import { ClienteCompleto } from '../../../../types/ClienteCompletoResponse.type';
import { Modulo } from '../../../../types/Modulo.type';

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getBasico(){
    return this.httpClient.get<ClienteBasicoResponse[]>(`${this.configService.getApiUrl()}/cliente/basico`);
  }

  getCliente(id: string){
    return this.httpClient.get<Cliente>(`${this.configService.getApiUrl()}/cliente/${id}`);
  }

  getClienteCompleto(id: string){
    return this.httpClient.get<ClienteCompleto>(`${this.configService.getApiUrl()}/cliente/completo/${id}`);
  }

  put(cliente: Cliente){
    return this.httpClient.put<Cliente>(`${this.configService.getApiUrl()}/cliente`, cliente);
  }

  post(cliente: Cliente){
    return this.httpClient.post<Cliente>(`${this.configService.getApiUrl()}/cliente`, cliente);
  }

  desativar(id: string){
    return this.httpClient.delete(`${this.configService.getApiUrl()}/cliente/${id}`);
  }

  ativar(id: string){
    return this.httpClient.put(`${this.configService.getApiUrl()}/cliente/ativar/${id}`, null);
  }

  getPermissoes(){
    return this.httpClient.get<Modulo[]>(`${this.configService.getApiUrl()}/permissao`);
  }
}
